import { Link } from "react-router-dom";
import type { Analysis } from "@/mocks/analyses";

interface AnalysisCardProps {
  analysis: Analysis;
}

export default function AnalysisCard({ analysis }: AnalysisCardProps) {
  return (
    <Link
      to={`/analysis?article=${analysis.id}`}
      className="group flex gap-4 bg-background-50 border border-background-200 rounded-lg p-3 md:p-4 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="w-28 h-24 md:w-40 md:h-28 rounded-md overflow-hidden shrink-0 bg-secondary-100">
        <img
          src={analysis.cover}
          alt={`${analysis.title} 赛事解析配图`}
          title={`${analysis.title} 足球解析`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex-1 flex flex-col">
        <div className="flex flex-wrap items-center gap-2 mb-1.5">
          {analysis.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {analysis.title}
        </h3>
        <p className="hidden md:block text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
          {analysis.excerpt}
        </p>
        <div className="flex items-center gap-3 mt-auto pt-2 text-xs text-foreground-400">
          <span>{analysis.date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {analysis.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}